import { render } from "./FireExtinguisherItems.vue?vue&type=template&id=6c5283e6"
import script from "./FireExtinguisherItems.vue?vue&type=script&lang=js"
export * from "./FireExtinguisherItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__